import React from 'react'
import Banner from '../Components/Banner'
import CoinsTable from '../Components/CoinsTable'

function Homepage() {
  return (
    <div>
      <Banner/>
      <CoinsTable/>
    </div>
  )
}

export default Homepage